<template>
  <picture>
    <source v-if="checkType('avif')" :srcset="getTypeSrc('avif')" type="image/avif">
    <source v-if="checkType('webp')" :srcset="getTypeSrc('webp')" type="image/webp">
    <source v-if="checkType('png')" :srcset="getTypeSrc('png')" type="image/x-png">
    <source v-if="checkType('jpg')" :srcset="getTypeSrc('jpg')" type="image/jpeg">
    <img :src="imgUrl" :alt="alt" :class="classes">
  </picture>
</template>

<script>
export default {
  props: {
    alt: {
      type: String,
      default: ''
    },
    classes: {
      type: String,
      default: ''
    },
    src: {
      type: Object,
      default: () => { return {} }
    }
  },
  computed: {
    imgUrl() {
      const src = this.src
      if (!src.multiple || !src.multiple.icon) {
        console.log(`Optimized img path not found for game: ${src.name}`)
        return src.image
      } else if (src.multiple.icon.hasOwnProperty('avif')) {
        return src.multiple.icon.avif
      } else if (src.multiple.icon.hasOwnProperty('webp')) {
        return src.multiple.icon.webp
      } else if (src.multiple.icon.hasOwnProperty('png')) {
        return src.multiple.icon.png
      } else if (src.multiple.icon.hasOwnProperty('jpg')) {
        return src.multiple.icon.jpg
      } else {
        return src.image
      }
    }
  },
  methods: {
    checkType(type) {
      if (this.src.multiple.icon.hasOwnProperty(type)) {
        return true
      } else return false
    },
    getTypeSrc(type) {
      if (this.src.multiple.icon.hasOwnProperty(type)) {
        return this.src.multiple.icon[type]
      } else return ''
    }
  }
}
</script>
